import { render, staticRenderFns } from "./ResListStu.vue?vue&type=template&id=392b858e&scoped=true&"
import script from "./ResListStu.vue?vue&type=script&lang=js&"
export * from "./ResListStu.vue?vue&type=script&lang=js&"
import style0 from "./ResListStu.vue?vue&type=style&index=0&id=392b858e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b858e",
  null
  
)

export default component.exports